// routes/index.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Import all your components
import Login from "../components/LoginModel";
import UmedwarLogin from "../pages/dashboardPages/electionRelated/loginForm";
import Register from "../components/RegisterModule";
import Navbar from "../components/Navbar";
import ServiceSlider from "../components/ServiceSlider";
import About from "../components/About";
import Services from "../components/Services";
import CallToAction from "../components/CallToAction";
import Portfolio from "../components/Portfolio";
import Team from "../components/TeamMembers";
import Testimonials from "../components/Testimonials";
import Clients from "../components/Clients";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import Career from "../components/Carrer";
import WebDevelopmentPage from "../pages/webDevelopment";
import AppDevelopmentPage from "../pages/appDevelopment";
import LogoDesign from "../pages/logoDesign";
import UiUxDevelopmentPage from "../pages/uiuxDevelopment";
import SeoDevelopmentPage from "../pages/seoDevelopment";
import DigitalMarketingDevelopmentPage from "../pages/digitalMarketingDevelopment";
import GraphicDevelopmentPage from "../pages/graphicDesignDevelopment";
import WebHostingPage from "../pages/webHostingDevelopment";
import TypesOfWebsites from "../components/TypesOfWebsite";
import GetQuote from "../pages/getAquote";

import DashboardLayout from "../components/Dashboard/dashboardLayout";
import StaffDashboard from "../pages/dashboardPages/Staff-dashboard";
import Contact from "../pages/dashboardPages/contact";
import JobOpeningDashboard from "../pages/dashboardPages/jobRelated/jobOpeningDashboard";
import AppliedCandidates from "../pages/dashboardPages/jobRelated/appliedcandidates";
import AllProject from "../pages/dashboardPages/projectmanagement/AllProjects";
import AllStaff from "../pages/dashboardPages/staffRealted/allStaff";
import LeaveManagement from "../pages/dashboardPages/staffRealted/leaveManage";
import SalaryManagement from "../pages/dashboardPages/staffRealted/salaryManage";
import BankAccount from "../pages/dashboardPages/bankAccount/bank";
import BankTransactions from "../pages/dashboardPages/bankAccount/transactions";
import ShikshaVistar from "../pages/dashboardPages/shikshaVistar/addSchool";
import ManageTransaction from "../pages/dashboardPages/shikshaVistar/manageTransaction";
import ManageId from "../pages/dashboardPages/Id-Card/addId";
import ManageIdTransaction from "../pages/dashboardPages/Id-Card/idTransactions";
import ManageStationary from "../pages/dashboardPages/stationaryManage/addStationary";
import ManageStationaryTransaction from "../pages/dashboardPages/stationaryManage/stationaryTransaction";

// election list
import UmedwarList from "../pages/dashboardPages/electionRelated/umedwarList";
import RegisterMatdar from "../pages/dashboardPages/electionRelated/addmatdar";

import MatdarDashboard from "../pages/dashboardPages/electionRelated/dashboard";
import MatdarWardLIst from "../pages/dashboardPages/electionRelated/wardVoterList";
import AccountManage from "../pages/dashboardPages/electionRelated/accountManage";



const Home = () => (
  <>
    <ServiceSlider />
    <Services />
    <About />
    <TypesOfWebsites />
    <CallToAction />
    <Portfolio />
    <Team />
    <ContactUs/>
  </>
);

function AppRouter() {
  const location = useLocation();

  // ✅ Check if current path includes "dashboard"
  const hideHeaderFooter =
    location.pathname.startsWith("/dashboard") ||
    location.pathname.startsWith("/matdar-dashboard");
    location.pathname.startsWith("/account-dashboard");
    location.pathname.startsWith("/matdar-dashboard/ward-wise-list");
    location.pathname.startsWith("/account-dashboard");
  return (
    <>
      {!hideHeaderFooter && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Umedwar-login" element={<UmedwarLogin/>} />
        <Route path="/register" element={<Register />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/career" element={<Career />} />
         <Route path="/register-matdar" element={<RegisterMatdar/>} />
         <Route path="/dashboard/umedwar-accounts" element={<AccountManage />} />
          <Route path="/matdar-dashboard" element={<MatdarDashboard/>} />
          <Route path="/matdar-dashboard/ward-wise-list/:wardno" element={<MatdarWardLIst/>} />
        <Route path="/web-development" element={<WebDevelopmentPage />} />
        <Route path="/app-development" element={<AppDevelopmentPage />} />
        <Route path="/logo-designing" element={<LogoDesign />} />
        <Route path="/ui-ux-design" element={<UiUxDevelopmentPage />} />
        <Route path="/seo" element={<SeoDevelopmentPage />} />
        <Route
          path="/digital-marketing"
          element={<DigitalMarketingDevelopmentPage />}
        />
        <Route path="/graphic-design" element={<GraphicDevelopmentPage />} />
        <Route path="/web-hosting" element={<WebHostingPage />} />
        <Route path="/get-a-quote" element={<GetQuote />} />

        {/* Dashboard Routes */}
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route path="staff-dashboard" element={<StaffDashboard />} />
          <Route path="contact" element={<Contact />} />
          <Route
            path="job-openings/dashboard"
            element={<JobOpeningDashboard />}
          />
          <Route
            path="job-openings/applied-candidates/:id"
            element={<AppliedCandidates />}
          />

          <Route path="project-manage" element={<AllProject />} />
          <Route path="all-staff" element={<AllStaff />} />
          <Route path="leave-management" element={<LeaveManagement />} />
          <Route path="salary-management" element={<SalaryManagement />} />
          <Route path="bank-account" element={<BankAccount />} />
          <Route
            path="bank-account/transactions"
            element={<BankTransactions />}
          />
          <Route path="/dashboard/shiksha-vistar" element={<ShikshaVistar />} />
          <Route
            path="/dashboard/transactions/:id"
            element={<ManageTransaction />}
          />
          <Route path="/dashboard/id-card" element={<ManageId />} />
          <Route
            path="/dashboard/idcard-transactions/:idCardId"
            element={<ManageIdTransaction />}
          />
          <Route path="/dashboard/stationary" element={<ManageStationary />} />
          <Route
            path="/dashboard/manage-stationary-transactions/:id"
            element={<ManageStationaryTransaction />}
          />
          {/* election related */}
          <Route path="/dashboard/umedwar-list" element={<UmedwarList />} />
        </Route> 
      </Routes>

      {!hideHeaderFooter && <Footer />}
    </>
  );
}

export default AppRouter;
